// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactModal from "react-modal";
import * as FareEstimateFormStore$PorterinFeature from "../../../../shared/core/constants/FareEstimateFormStore.mjs";
import * as PnMFareEstimateFormCmp$PorterinFeature from "./PnMFareEstimateFormCmp.mjs";
import * as PnMFareEstimateModalModuleScss from "../styles/PnMFareEstimateModal.module.scss";
import * as PnMFareEstimateModalLayoutCmp$PorterinFeature from "./PnMFareEstimateModalLayoutCmp.mjs";
import * as PnMFareEstimateInputModalModuleScss from "../styles/PnMFareEstimateInputModal.module.scss";
import * as FareEstimateModalModuleScss from "../../../../shared/modal/view/styles/FareEstimateModal.module.scss";

var modal_form_styles = PnMFareEstimateModalModuleScss;

var input_field_styles = PnMFareEstimateInputModalModuleScss;

var styles = FareEstimateModalModuleScss;

function PnMFareEstimateModalCmp(Props) {
  var modal_state = Props.modal_state;
  var close_modal = Props.close_modal;
  var show_house_field = Props.show_house_field;
  return React.createElement(ReactModal, {
              isOpen: modal_state,
              onRequestClose: close_modal,
              closeTimeoutMS: 0,
              overlayClassName: styles.overlay,
              className: "" + styles["modal-container"] + "",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement(PnMFareEstimateModalLayoutCmp$PorterinFeature.make, {
                    title: FareEstimateFormStore$PorterinFeature.pnm_title,
                    sub_title: FareEstimateFormStore$PorterinFeature.pnm_sub_title,
                    title_mobile: FareEstimateFormStore$PorterinFeature.pnm_title_mobile,
                    children: React.createElement(PnMFareEstimateFormCmp$PorterinFeature.make, {
                          styles: modal_form_styles,
                          input_field_styles: input_field_styles,
                          show_house_size: show_house_field
                        }),
                    close_modal: close_modal
                  })
            });
}

var make = PnMFareEstimateModalCmp;

export {
  modal_form_styles ,
  input_field_styles ,
  styles ,
  make ,
}
/* modal_form_styles Not a pure module */
